var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedirect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_61_90",
    "data-name": "Component 61 \\u2013 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2679",
    "data-name": "Rectangle 2679",
    width: 16,
    height: 16,
    fill: "#600097"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13075",
    "data-name": "Group 13075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13075-2",
    "data-name": "Group 13075",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12994",
    "data-name": "Path 12994",
    d: "M7.11,16c-.318-.042-.637-.068-.95-.127a8.24,8.24,0,0,1-6.071-4.41.754.754,0,0,1,.365-1.04.824.824,0,0,1,1.106.367,6.493,6.493,0,0,0,1.858,2.228A6.755,6.755,0,0,0,8.151,14.41a6.631,6.631,0,0,0,5.992-4.776A6.44,6.44,0,0,0,9.1,1.717a6.832,6.832,0,0,0-7.5,3.43.845.845,0,0,1-.963.5A.775.775,0,0,1,.1,4.521,7.946,7.946,0,0,1,2.5,1.684,8.518,8.518,0,0,1,7.984.005a8.253,8.253,0,0,1,7.889,6.616c.051.292.085.586.127.88v1c-.009.04-.021.08-.027.12-.057.371-.093.745-.172,1.111A8.217,8.217,0,0,1,9.09,15.877c-.31.048-.622.082-.935.123Z",
    transform: "translate(0 0)",
    fill: "#600097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12995",
    "data-name": "Path 12995",
    d: "M9.115,7.214c-.426-.406-.818-.773-1.2-1.148a.758.758,0,0,1,.132-1.215.848.848,0,0,1,1.032.119c.354.332.7.669,1.052,1,.308.295.617.588.924.884a1.476,1.476,0,0,1,0,2.272c-.658.63-1.314,1.262-1.976,1.888a.838.838,0,0,1-1.3-.148.749.749,0,0,1,.146-.959c.382-.37.772-.735,1.195-1.138H8.91q-2.213,0-4.426,0A.792.792,0,0,1,3.67,7.8a.818.818,0,0,1,.839-.588q2.188,0,4.378,0Z",
    transform: "translate(0.175 0.008)",
    fill: "#600097"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirect);
export default __webpack_public_path__ + "static/media/redirect.e8f66a0346525d341f180287e8a9059f.svg";
export { ForwardRef as ReactComponent };